export default (state = [], payload) => {
    switch(payload.type) {
        case 'MEDIALIBRARY':
            return JSON.parse(payload.data);   
        // case 'MEDIA_LIBRARY_DRAWER':
        //     return payload.data;         
        default:
            return state;
    }
}